import { render } from "./DeviceColor.vue?vue&type=template&id=5848729c&scoped=true&ts=true&lang=pug"
import script from "./DeviceColor.vue?vue&type=script&lang=ts"
export * from "./DeviceColor.vue?vue&type=script&lang=ts"

import "./DeviceColor.vue?vue&type=style&index=0&id=5848729c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5848729c"]])

export default __exports__